import Model, { Request } from '../model'
import APIObject from '../object'
import Enum from '../enums'

export default class ContentTemplate extends Model {
  static modelName () {
    return 'contentTemplate'
  }

  objectID () {
    return this.idContentTemplate
  }

  relations () {
    return {
      customerMessageType: { type: ContentTemplateCustomerMessageType },
      type: { type: ContentTemplateType },
      overrides: { type: ContentTemplateOverride },
      options: { type: ContentTemplateOption },
    }
  }

  requestJSON () {
    const object = {
      type: this.type?.value,
      customerMessageType: this.customerMessageType?.value,
      name: this.name,
      emailSubject: this.emailSubject,
      smsBody: this.smsBody,
      enabled: this.enabled,
    }

    if (this.overrides.slots) {
      object.emailSlots = {}
      for (const slot of this.overrides.slots) {
        object.emailSlots[slot.name] = slot.value
      }
    }

    if (this.overrides.options) {
      object.emailOptions = {}
      for (const option of this.overrides.options) {
        object.emailOptions[option.name] = option.value
      }
    }

    return object
  }

  static list (page = 1, filters = {}) {
    let url = this.modelBaseURL() + '/?page=' + page

    for (const filter in filters) {
      if (filters[filter] !== null) {
        url += `&${filter}=${filters[filter]}`
      }
    }

    return this.requestList(Request.get(url), this)
  }

  preview () {
    const url = this.constructor.modelBaseURL() + '/preview'

    return this.constructor.requestData(Request.jsonPost(url, this.requestJSON()))
  }
}

export class ContentTemplateOverride extends APIObject {
  relations () {
    return {
    }
  }
}

export class ContentTemplateOption extends APIObject {
  relations () {
    return {
    }
  }
}


export const ContentTemplateType = new Enum({
  serviceAutomation: { value: 1, description: 'Service Automation' },
  campaign: { value: 2, description: 'Campaign' },
  customerMessage: { value: 3, description: 'Customer Message' },
})

export const ContentTemplateCustomerMessageType = new Enum({
  newReservation: { value: 1, description: 'New Appointment' },
  newReservationConfirmed: { value: 2, description: 'New Appointment Confirmed' },
  newReservationCancelled: { value: 4, description: 'New Appointment Cancelled' },
  newReservationReminder: { value: 5, description: 'New Appointment Reminder' },
  reservationMoved: { value: 6, description: 'Appointment Moved' },
  reservationCancelled: { value: 7, description: 'Appointment Cancelled' },
  reservationReminder: { value: 8, description: 'Appointment Reminder' },
  newSale: { value: 9, description: 'New Sale' },
  passwordReset: { value: 10, description: 'Password Reset' },
  receivedCampaign: { value: 11, description: 'Received Campaign' },
  general: { value: 12, description: 'General' },
  loginCode: { value: 13, description: 'Login Code' },
  newCustomer: { value: 14, description: 'New Customer' },
  newOrder: { value: 15, description: 'New Order' },
  newCustomerCourse: { value: 16, description: 'New Customer Course' },
  waitlistOffer: { value: 17, description: 'Waitlist Offer' },
  checkInReservation: { value: 18, description: 'Check In Appointment' },
  noShowReservation: { value: 19, description: 'No Show Appointment' },
  confirmReservation: { value: 20, description: 'Confirm Appointment' },
  reviewReservation: { value: 21, description: 'Review Appointment' },
  nextReservationReminder: { value: 22, description: 'Next Appointment Reminder' },
  resetPasswordRequest: { value: 23, description: 'Reset Password Request' },
  massEmail: { value: 24, description: 'Mass Email' },
  massSms: { value: 25, description: 'Mass SMS' },
  birthdayMessage: { value: 26, description: 'Birthday Message' },
  passExpiringReminder: { value: 27, description: 'Pass Expiring Reminder' },
  passExpiredReminder: { value: 28, description: 'Pass Expired Reminder' },
  formRequest: { value: 29, description: 'Form Request' },
  orderPaymentRequest: { value: 30, description: 'Order Payment Request' },
  minisiteLogin: { value: 31, description: 'Minisite Login' },
  waitlistAdd: { value: 32, description: 'Waitlist Add' },
  moveReservation: { value: 33, description: 'Move Appointment' },
  form: { value: 34, description: 'Form' },
  giftCard: { value: 35, description: 'Gift Card' },
  giftPass: { value: 36, description: 'Gift Pass' },
  customerConfirmed: { value: 38, description: 'Customer Confirmed' },
  serviceAutomationMessage: { value: 39, description: 'Service Automation Message' },
})
